const constantSuggestionLoveMatter: any = {
  love_science_technology: {
    text: '🧭 TROIS VOIES D’ORIENTATION PRIVILÉGIÉES :',
    subtitle: [
      'Voici trois voies que tu pourrais emprunter pour atteindre tes objectifs en fonction de tes résultats scolaires :',
    ],
    list: [
      "Pour les élèves avec d'excellents résultats (moyenne ≥15) : classe préparatoire Mathspé MP/MP suivie par une grande école d'ingénieur(e).",
      "Pour les élèves avec de bons résultats (moyenne ≥12) : école d'ingénieur(e) en accès postbac (avec ou sans prépa intégré) ou licence universitaire scientifique.",
      'Pour les élèves avec des résultats moyens (moyenne ≥10) : BUT de sciences (SGM, Génie bio...) ou BTS à dominante scientifique (aéronautique, biotechnologies, etc.).',
    ],
    citation:
      '« La science présente beaucoup de danger, mais il faut lutter contre ces dangers non pas par moins de science mais par davantage de science, une science qui puisse aussi créer sa propre éthique. »',
    author: "Jean d'Ormesson",
    subtitle2: [],
  },
  love_trade_economy: {
    text: '🧭 TROIS VOIES D’ORIENTATION PRIVILÉGIÉES :',
    subtitle: [
      'Voici trois voies que tu pourrais emprunter pour atteindre tes objectifs en fonction de tes résultats scolaires :',
    ],
    list: [
      "Pour les élèves avec d'excellents résultats (moyenne ≥15) : classe préparatoire ECE suivie par une grande école de commerce.",
      "Pour les élèves avec de bons résultats (moyenne ≥12) : licence d'économie à l'université ou BUT GEA/Techniques de commercialisation.",
      "Pour les élèves avec des résultats moyens (moyenne ≥10) : école de commerce postbac sans concours d'entrée ou BTS NDRC/MCO.",
    ],
    citation: "« Mieux vaut gagner dans le commerce de paille que perdre dans celui de l'or. »",
    author: 'Proverbe serbe',
    subtitle2: [],
  },
  love_law_political_science: {
    text: '🧭 TROIS VOIES D’ORIENTATION PRIVILÉGIÉES :',
    subtitle: [
      'Voici trois voies que tu pourrais emprunter pour atteindre tes objectifs en fonction de tes résultats scolaires :',
    ],
    list: [
      "Pour les élèves avec d'excellents résultats (moyenne ≥15) : IEP (Instituts d'Étude Politique) en visant le Graal Sciences Po Paris.",
      'Pour les élèves avec de bons résultats (moyenne ≥12) : licence universitaire en UFR de droit.',
      "Pour les élèves avec des résultats moyens (moyenne ≥10) : DUT juridiques (Carrières juridiques...) ou BTS notariat.",
    ],
    citation: '« Si vous avez la force, il nous reste le droit. »',
    author: 'Victor Hugo',
    subtitle2: [],
  },
  love_arts_communication: {
    text: '🧭 TROIS VOIES D’ORIENTATION PRIVILÉGIÉES :',
    subtitle: [
      'Voici trois voies que tu pourrais emprunter pour atteindre tes objectifs en fonction de tes résultats scolaires :',
    ],
    list: [
      "Pour les élèves avec d'excellents résultats (moyenne ≥15) : classes préparatoires art et design ou MANAA. Certains BTS très cotés comme Olivier de Serre.",
      "Pour les élèves avec de bons résultats (moyenne ≥12) : BUT Info/com ou Techniques de commercialisation, licence universitaire aux Beaux-arts ou en histoire de l'art.",
      'Pour les élèves avec des résultats moyens (moyenne ≥10) : BTS design, communication, DN MADE, etc.',
    ],
    subtitle2: [
      'Quelle que soit la filière, il est recommandé de réaliser ses études à Paris ou dans une grande métropole où sont concentrés les emplois de la communication.',
    ],
    citation: '« L’art n’est pas un mensonge. »',
    author: 'Gustave Flaubert',
  },
  love_health_care: {
    text: '🧭 TROIS VOIES D’ORIENTATION PRIVILÉGIÉES :',
    subtitle: [
      'Voici trois voies que tu pourrais emprunter pour atteindre tes objectifs en fonction de tes résultats scolaires :',
    ],
    list: [
      'Pour les élèves avec d’excellents résultats (moyenne ≥15) : licence universitaire PASS.',
      'Pour les élèves avec de bons résultats (moyenne ≥12) : licence universitaire avec option santé.',
      'Pour les élèves avec des résultats moyens (moyenne ≥10) : licence universitaire de psychologie, BTS diététique, etc.',
    ],
    citation: '« Que ton aliment soit ta seule médecine ! »',
    author: 'Hippocrate',
    subtitle2: [
      'Les études de santé nécessitent un solide niveau et une grande appétence pour les matières scientifiques.',
    ],
  },
  love_letter_humanities: {
    text: '🧭 TROIS VOIES D’ORIENTATION PRIVILÉGIÉES :',
    subtitle: [
      'Voici trois voies que tu pourrais emprunter pour atteindre tes objectifs en fonction de tes résultats scolaires :',
    ],
    list: [
      "Pour les élèves avec d'excellents résultats (moyenne ≥15) : classes préparatoires lettres (il en existe différentes sortes).",
      "Pour les élèves avec de bons résultats (moyenne ≥12) : licence universitaire lettres ou sciences humaines, DUT carrières sociales.",
      "Pour les élèves avec des résultats moyens (moyenne ≥10) : je ne recommande pas de s'engager dans cette voie en cas de résultats moyens à moins d'une solide motivation.",
    ],
    citation: "« La poésie est une lettre d'amour adressée au monde. »",
    author: 'Charlie Chaplin',
    subtitle2: [
      "Les études de lettres et sciences humaines n'offrent de réels débouchés que pour les élèves les plus travailleur(se)s et les plus autonomes.",
    ],
  },
} as const;

export default constantSuggestionLoveMatter;


